module.exports = __webpack_public_path__ + "static/img/5054_phase_function_Paper_PointsHejduk_Prediction.9770c6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5054_phase_function_Paper_PointsHejduk_Prediction.png
// module id = yC/S
// module chunks = 0